const angular = require('angular');

angular.module('wowApp.shop')
    // Service
    .service('ProductRecommendationService', ['RestangularV3', '$window', 'Settings', 'BreakpointsService', require('./productrecommendation.service')]);



// WEBPACK FOOTER //
// ./src/shop/productrecommendation/index.js